<template>
  <div class="download-section">
    <div v-if="reports && reports.length" class="reports-container">
      <div class="reports">
        <download-files v-for="(report, i) in reports" :key="i" :name="report.period" :files="getReportFiles(report)" />
      </div>
    </div>
    <ets-alert v-else-if="reports" type="info">
      No se ha generado todavía ningún trámite.
    </ets-alert>
    <ets-popup
      v-if="isPopupVisible"
      class="reports-popup"
      title="Nuevo trámite"
      :hide-footer="uploading"
      @close="isPopupVisible = false"
      @accept="onPopupAccept"
    >
      <ets-spinner v-if="uploading" />
      <ets-alert v-else-if="success" type="success">Se ha cargado el fichero correctamente</ets-alert>
      <div v-else>
        <label>Periodo</label>
        <ets-dropdown class="dropdown" v-model="period" :items="dropdownItems" />
        <ets-file-dropper @dropped="onFileDropped" />
        <ets-alert v-if="uploadError" type="error">{{ uploadErrorMessage }}</ets-alert>
      </div>
    </ets-popup>
  </div>
</template>

<script>
import compliance from "@/logic/api/compliance";
import DownloadFiles from "@/components/Download/DownloadFiles";

export default {
  components: {
    DownloadFiles
  },
  props: {
    procedure: {
      type: String,
      required: true,
      validator(value) {
        return compliance.getProcedureTypes().includes(value);
      }
    }
  },
  data: () => ({
    reports: null,
    period: null,
    isPopupVisible: false,
    success: false,
    uploading: false,
    uploadFile: null,
    uploadError: false,
    uploadErrorMessage: ""
  }),
  computed: {
    procedureType() {
      return compliance.getProcedure(this.procedure);
    },
    periods() {
      const isAnnual = this.procedureType.period.each === 12;

      const toPeriod = (year, quarter) => {
        return isAnnual ? `${year}` : `${year}${this.procedureType.period.symbol}${quarter}`;
      };

      const today = new Date();
      const newestPeriod = { year: today.getFullYear() };
      if (!isAnnual) newestPeriod.quarter = Math.floor(today.getMonth() / this.procedureType.period.each) + 1;

      const periods = [];
      const firstReport = this.reports.length > 0 ? this.reports[this.reports.length - 1] : null;
      if (firstReport) {
        if (isAnnual) {
          const matched = firstReport.period.match(this.procedureType.period.regex);
          const oldestPeriod = {
            year: parseInt(matched[1])
          };
          for (let year = oldestPeriod.year; year <= newestPeriod.year; year++) {
            periods.push(toPeriod(year));
          }
        } else {
          const matched = firstReport.period.match(this.procedureType.period.regex);
          const oldestPeriod = {
            year: parseInt(matched[1]),
            quarter: parseInt(matched[2])
          };
          for (let year = oldestPeriod.year; year <= newestPeriod.year; year++) {
            const minQuarter = year === oldestPeriod.year ? oldestPeriod.quarter : 1;
            const maxQuarter = year === newestPeriod.year ? newestPeriod.quarter : 12 / this.procedureType.period.each;
            for (let quarter = minQuarter; quarter <= maxQuarter; quarter++) {
              periods.push(toPeriod(year, quarter));
            }
          }
        }
      } else {
        periods.push(toPeriod(newestPeriod.year, newestPeriod.quarter));
      }
      return periods.reverse();
    },
    dropdownItems() {
      return this.periods.map(x => ({ text: x, value: x }));
    }
  },
  methods: {
    async fetchReports() {
      const response = await this.procedureType.fetch();
      this.reports = response.data.reverse();
      this.$emit("reports-loaded", this.reports);
    },
    getReportFiles(report) {
      return report.file_names.map(fileName => ({
        url: `${this.procedureType.baseUrl}${fileName}`,
        name: fileName
      }));
    },
    initGenerationNewFile() {
      this.period = this.dropdownItems[0];
      this.success = false;
      this.uploading = false;
      this.uploadFile = null;
      this.uploadError = false;
      this.isPopupVisible = true;
    },
    onFileDropped(file) {
      this.uploadFile = file;
    },
    onChangeFile(event) {
      this.uploadFile = event.target.files[0];
    },
    async onPopupAccept() {
      if (this.success) this.isPopupVisible = false;
      else {
        try {
          this.uploading = true;
          this.uploadError = false;
          await this.procedureType.generate(this.period.value, this.uploadFile);
          this.uploading = false;
          this.success = true;
          await this.fetchReports();
        } catch (e) {
          this.uploading = false;
          this.uploadError = true;
          if (e !== null && e !== "undefined") {
            this.uploadErrorMessage = e.message;
          } else {
            this.uploadErrorMessage = "Error Interno. Consulta con el equipo de IT.";
          }
        }
      }
    }
  },
  async created() {
    await this.fetchReports();
  }
};
</script>

<style lang="scss" scoped>
.reports-container {
  display: flex;
  justify-content: center;
}
.reports {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.reports-popup ::v-deep .content {
  min-width: 500px;
}
.dropdown {
  margin: 1rem 0 2rem;
  display: block;
}
</style>
